import React from 'react';
import PropTypes from 'prop-types';
import { motion } from 'framer-motion';
import { v4 as uuidv4 } from 'uuid';

const variants = {
  initial: {
    height: 0,
    opacity: 0,
  },
  animate: {
    height: 'auto',
    opacity: 1,
    transition: { duration: 0.4, when: 'beforeChildren' },
  },
};
const UploadReport = ({ report }) => {
  return (
    <motion.div layout initial="initial" animate="animate" variants={variants}>
      <p className="border-t-8 border-primary text-xl font-bold uppercase tracking-wide my-4 pt-4">
        Report
      </p>
      <motion.div
        variants={variants}
        className="table border w-full border-gray-500 border-collapse text-gray-700 p-2"
      >
        <div className="table-row text-sm font-semibold uppercase">
          <p className="table-cell p-2">Object ID</p>
          <p className="table-cell p-2">Transmission</p>
          <p className="table-cell p-2">Status</p>
          <p className="table-cell p-2">Messages</p>
        </div>
        <div className="table-row-group">
          {report.report.map((row) => {
            return (
              <div key={uuidv4()} className="table-row border-t-2 text-sm">
                <span className="table-cell p-2">{row.object}</span>
                <span className="table-cell p-2">{row.transmission}</span>
                <span className="table-cell p-2">
                  <span
                    className={`${
                      row.status === 'success'
                        ? 'bg-green-100 border-green-300'
                        : 'bg-red-200 border-red-300'
                    } rounded-full border py-1 px-2 text-xs`}
                  >
                    {row.status === 'success' ? 'Uploaded to OTM' : 'Failed'}
                  </span>
                </span>
                <span className="table-cell p-2">
                  {row.messages.length ? (
                    row.messages.map((msg) => <span key={uuidv4()}>{msg}</span>)
                  ) : (
                    <span>-</span>
                  )}
                </span>
              </div>
            );
          })}
        </div>
      </motion.div>
    </motion.div>
  );
};

UploadReport.propTypes = {
  report: PropTypes.shape({
    report: PropTypes.arrayOf(
      PropTypes.shape({
        object: PropTypes.string.isRequired,
        status: PropTypes.string.isRequired,
        transmission: PropTypes.string.isRequired,
        messages: PropTypes.arrayOf(PropTypes.string).isRequired,
      })
    ).isRequired,
  }),
};

export default UploadReport;
